export default __webpack_public_path__ + "static/media/alertErrorIcon.bff623f5.svg";